import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import Logo from "../../assets/LAETUS.png";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import { UseWindowSize } from "../../hooks/Usewindow";
import { useSelector, useDispatch } from "react-redux";
import Inputfield from "../../components/Textfield/Textfield";
import { API } from "aws-amplify";
import { createUserInfo } from "../../graphql/mutations";
import { login } from "../../store/action";
import { useHistory } from "react-router-dom";
import "./CheckUserName.scss";

export default function CheckUserName() {
	const dispatch = useDispatch();
	const history = useHistory();
	const [checkName, setCheckName] = useState("");
	const { t } = useTranslation();
	const logins = useSelector((state) => state.login);
	const [loader2, setloader2] = useState(false);
	const width = UseWindowSize();
	const saveusername = async () => {
		setloader2(true);
		const user = {
			userId: logins.userDetail,
			userName: checkName,
			email: logins.email,
			paypalEmail: "",
			accountNo: "",
			ibanNo: "",
			WebflowCustomerId: "",
		};
		await API.graphql({
			query: createUserInfo,
			authMode: "API_KEY",
			variables: {
				input: user,
			},
		});
		dispatch(
			login({
				WebflowCustomerId: "",
				checkName: false,
				userName: checkName,
			}),
		);
		history.push("/home");
		setloader2(false);
	};

	return (
		<>
			<Container style={{ paddingLeft: "5px" }} className="container-width">
				<div className="auth-page-logo">
					<img src={Logo} alt="logo" />
				</div>
				<div className="auth-page-bottom">
					<Grid
						xs={12}
						lg={12}
						md={12}
						style={{ margin: width.width < 601 && "0 10px 0 10px" }}
					>
						<h2>{t("enter_name")}</h2>
						<Inputfield
							type="text"
							value={checkName}
							onChange={(e) => setCheckName(e.target.value)}
							placeholder={t("check_name")}
						/>
						<div className="savebtn">
							<Button
								text={t("save")}
								onClick={() => saveusername()}
								style={{ marginTop: "20px" }}
								loader={loader2}
							/>
						</div>
					</Grid>
				</div>
			</Container>
		</>
	);
}
